import styled from "@emotion/styled";
import {
  Box,
  Button,
  InputBase,
  Typography,
  useTheme,
  Slider,
} from "@mui/material";
import Web3 from "web3";
import { Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { leftArrow } from "../../../assets";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { useAPIActions, useUIActions } from "../../../hooks/useActions";
import {
  getSigAndKey,
  lendNFT,
  lendNft,
  verifyAndlendNFT,
} from "../../../contract";
import {
  GEORLI_SUBGRAPH_URL,
  GET_BORROWER_ACCOUNT_FOR_LENDER,
  nftTempImage,
  ON_LEND,
  REWARD_TOKEN_ADDRESS,
  SERVER_BASE_URL,
} from "../../../constants";
import { tokens } from "../../../theme";
import {
  FETCH_ALL_LENDED_NFT_QUERY,
  FETCH_LENDING_NFTS_FOR_SPECIFIC_SCHOLAR,
  ZERO_ADDRESS,
} from "../../../contract/contract-constant";
import fetchApi from "../../../utils/fetch";

const StyledButton = styled(Button)(({ theme, colors }) => ({
  backgroundColor: colors.primary[500],
  color: `${colors.whiteAccent[900]} !important`,
  marginTop: "30px",
  fontSize: "14px",
  fontWeight: 400,
  width: "100%",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const YieldSplit = ({ setStep }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [nft, setNft] = useState({});
  const [nftDestination, setNftDestination] = useState("");
  const [yieldDestination, setYieldDestination] = useState("");
  const [guildSplit, setGuildSplit] = useState("20");
  const [amount, setAmount] = useState("");
  const [isBackeSpacePressed, setIsBackeSpacePressed] = useState(false);

  const { account, chainId } = useWeb3React();
  const { address, tokenId } = useParams();
  const navigate = useNavigate();
  const { setLoading, setSnackbar } = useUIActions();
  const { updateProfileNfts, updateAllUsers } = useAPIActions();

  const { profileNfts, users } = useTypedSelector((state) => state.apiReducer);

  useEffect(() => {
    setNft(
      profileNfts.find(
        (nft) => nft.tokenId === tokenId && nft.nftAddress === address
      )
    );
  }, []);

  useEffect(() => {
    setNft(
      profileNfts.find(
        (nft) => nft.tokenId === tokenId && nft.nftAddress === address
      )
    );
  }, [profileNfts]);

  function valuetext(value) {
    return <span style={{ color: "black !important" }}>{`${value}%`}</span>;
  }

  const validateAddress = () => {
    if (!Web3.utils.isAddress(nftDestination)) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Nft Destination Address is not valid!",
      });
      return false;
    } else if (!Web3.utils.isAddress(yieldDestination)) {
      setSnackbar({
        open: true,
        severity: "error",
        message: "Yield Destination Address is not valid!",
      });
      return false;
    }
    return true;
  };

  const isEOAVerified = () => {
    const EOAFromSubgraph = users.find(
      (user) => user.id === nftDestination.toLowerCase()
    );
    if (EOAFromSubgraph && EOAFromSubgraph?.isVerified === true) {
      return true;
    } else {
      return false;
    }
  };

  const lendCallback = async (msg, status) => {
    let responseLentNfts = await fetchApi(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_ALL_LENDED_NFT_QUERY(account),
      },
      "post"
    );
    let allNftsFromSubgraph = responseLentNfts?.payload?.data?.lends;
    console.log(
      "allNftsFromSubgraph",
      allNftsFromSubgraph,
      profileNfts.filter((nft) => nft.status === ON_LEND)
    );
    if (status) {
      var intervalVar = setInterval(async () => {
        responseLentNfts = await fetchApi(
          GEORLI_SUBGRAPH_URL,
          {
            query: FETCH_ALL_LENDED_NFT_QUERY(account),
          },
          "post"
        );
        allNftsFromSubgraph = responseLentNfts?.payload?.data?.lends;

        console.log(
          "allNftsFromSubgraph",
          allNftsFromSubgraph.length,
          profileNfts.filter((nft) => nft.status === ON_LEND).length
        );

        if (
          allNftsFromSubgraph.length >
          profileNfts.filter((nft) => nft.status === ON_LEND).length
        ) {
          clearInterval(intervalVar);
          const newNftFromSubgraph = allNftsFromSubgraph.find(
            (nftS) =>
              nftS?.nftAddress === nft?.nftAddress &&
              nftS.tokenId === nft.tokenId
          );
          console.log("newNftFromSubgraph", newNftFromSubgraph);
          await updateProfileNfts(
            profileNfts,
            nft?.tokenId,
            nft?.nftAddress,
            ON_LEND,
            newNftFromSubgraph?.lendingId,
            chainId
          );

          setLoading(false);
          setSnackbar({
            open: true,
            severity: status ? "success" : "error",
            message: msg,
          });

          navigate(`/collections/${address}`);
        }
      }, 5000);
    }
  };

  const isValidRewardToken = async () => {
    let responseLendNftForScholarSpecific = await fetchApi(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_LENDING_NFTS_FOR_SPECIFIC_SCHOLAR(nftDestination),
      },
      "post"
    );
    const lendNftForScholarSpecific =
      responseLendNftForScholarSpecific?.payload?.data?.lends;
    const lenderAddresses = lendNftForScholarSpecific.map((nft) =>
      nft.lender.id.toLowerCase()
    );
    const RTAddresses = lendNftForScholarSpecific.map((nft) =>
      nft.rewardTokenAddress.toLowerCase()
    );

    if (lendNftForScholarSpecific.length > 0) {
      if (!lenderAddresses.includes(account.toLowerCase())) {
        if (RTAddresses.includes(yieldDestination.toLowerCase())) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const onConfirm = async () => {
    try {
      if (validateAddress()) {
        const lendingParams = [
          {
            borrower: nftDestination,
            nft: nft?.nftAddress,
            lendAmount: nft?.contractType === "ERC1155" ? amount : 0,
            tokenId: nft?.tokenId,
            split: guildSplit,
            rewardToken: yieldDestination,
            adapter: ZERO_ADDRESS,
          },
        ];

        setLoading(true);
        const isRTAValid = await isValidRewardToken();
        console.log("isRTAValid", { isRTAValid });
        if (isRTAValid) {
          if (isEOAVerified()) {
            console.log("**************RUNNING LEND NFT**************");
            await lendNFT(lendingParams, account, lendCallback);
          } else {
            console.log(
              "**************RUNNING VERIFY AND LEND NFT**************"
            );
            const sigAndKey = await getSigAndKey(nftDestination);
            if (!sigAndKey?.sig || !sigAndKey?.encrypted) {
              throw new Error("Invalid EOA Address!");
            }
            const { sig, encrypted } = sigAndKey;
            console.log("{sig, encrypted}", { sig, encrypted });
            await verifyAndlendNFT(
              lendingParams,
              [sig],
              [encrypted],
              account,
              async (msg, status) => {
                await lendCallback(msg, status);
                // update users from subgraph
                if (status) await updateAllUsers(users);
              }
            );
          }
        } else {
          setLoading(false);
          setSnackbar({
            open: true,
            severity: "info",
            message: "Please Change Yield Destination Address",
          });
        }
      } else {
        return;
      }
    } catch (e) {
      console.log("err in onconfirm", e);
      setLoading(false);
      if (e.message === "Invalid EOA Address!") {
        setSnackbar({
          open: true,
          severity: "error",
          message: e.message,
        });
      }
    }
  };

  return (
    <>
      <img
        src={leftArrow}
        alt="arrow"
        onClick={() => setStep(0)}
        style={{ marginTop: "10px" }}
      />

      <Stack
        direction="row"
        alignItems={"flex-start"}
        justifyContent="space-between"
        width="100%"
        sx={{ marginTop: "20px" }}
      >
        {/* <Box> */}
        <img
          src={nft?.image}
          alt="nft"
          style={{
            width: "424px",
            height: "418px",
            borderRadius: "7px",
          }}
          onError={(e) => (e.currentTarget.src = nftTempImage)}
        />
        {/* </Box> */}
        <Box
          sx={{
            height: "350px",
            width: "70%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            marginTop: "40px",
            marginLeft: "20px",
          }}
        >
          <Box
            width="100%"
            height="49px"
            bgcolor={colors.whiteAccent[900]}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="overline"
              fontWeight={400}
              align="center"
              textAlign={"center"}
              width={"100%"}
              color={colors.black[500]}
            >
              NFT Destination Address
            </Typography>
          </Box>

          <Box
            width="100%"
            height="49px"
            bgcolor={"#F9F8FD"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "10px",
              "& input": {
                textAlign: "center",
              },
            }}
          >
            <InputBase
              sx={{
                flex: 1,
                fontSize: "14px",
                border: "1px solid #E8ECF5",
                height: "100%",
              }}
              placeholder="Address"
              value={nftDestination}
              onChange={(e) => setNftDestination(e.target.value)}
            />
          </Box>

          <Box
            width="100%"
            height="49px"
            bgcolor={colors.whiteAccent[900]}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="overline"
              fontWeight={400}
              align="center"
              textAlign={"center"}
              width={"100%"}
              color={colors.black[500]}
            >
              Yield Destination Address
            </Typography>
          </Box>

          <Box
            width="100%"
            height="49px"
            bgcolor={"#F9F8FD"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "10px",
              "& input": {
                textAlign: "center",
              },
            }}
          >
            <InputBase
              sx={{
                flex: 1,
                fontSize: "14px",
                border: "1px solid #E8ECF5",
                height: "100%",
              }}
              placeholder="Address"
              value={yieldDestination}
              onChange={(e) => setYieldDestination(e.target.value)}
            />
          </Box>

          {nft?.contractType === "ERC1155" && (
            <>
              <Box
                width="100%"
                height="49px"
                bgcolor={colors.whiteAccent[900]}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="overline"
                  fontWeight={400}
                  align="center"
                  textAlign={"center"}
                  width={"100%"}
                  color={colors.black[500]}
                >
                  Amount
                </Typography>
              </Box>

              <Box
                width="100%"
                height="49px"
                bgcolor={"#F9F8FD"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "10px",
                  "& input": {
                    textAlign: "center",
                  },
                }}
              >
                <InputBase
                  sx={{
                    flex: 1,
                    fontSize: "14px",
                    border: "1px solid #E8ECF5",
                    height: "100%",
                  }}
                  placeholder="Amount"
                  value={amount}
                  onChange={(e) => {
                    const { value } = e.target;

                    const reg = /^[0-9\b]+$/;
                    const test = reg.test(value);

                    if (
                      (!test && !isBackeSpacePressed) ||
                      Number(value) > Number(nft?.balance)
                    ) {
                      return;
                    }

                    setAmount(e.target.value);
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 8) {
                      setIsBackeSpacePressed(true);
                    } else {
                      setIsBackeSpacePressed(false);
                    }
                  }}
                />
              </Box>
            </>
          )}
          <Box
            width="100%"
            height="49px"
            bgcolor={colors.whiteAccent[900]}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="overline"
              fontWeight={400}
              align="center"
              textAlign={"center"}
              width={"100%"}
              color={colors.black[500]}
            >
              Split Earnings
            </Typography>
          </Box>

          <Box
            width="100%"
            height="49px"
            bgcolor={"#F9F8FD"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& input": {
                textAlign: "center",
              },
            }}
          >
            <Slider
              aria-label="Always visible"
              // classes={{ valueLabel: classes.valueLabel }}
              value={guildSplit}
              onChange={(e) => {
                if (e.target.value === 100) return;
                if (e.target.value === 0) return;
                setGuildSplit(e.target.value);
              }}
              valueLabelFormat={valuetext}
              step={1}
              valueLabelDisplay="on"
              sx={{
                "& .MuiSlider-thumb": {
                  // borderRadius: "11px",
                  background: colors.primary[500],
                  border: "2.6px solid #ffffff",
                  width: "32px",
                  height: "32px",
                },
                "& .MuiSlider-track": {
                  background: colors.primary[500],
                  height: "16px",
                  borderRadius: "0px",
                },

                "& .MuiSlider-rail": {
                  background: "#ffffff",
                  height: "16px",
                  borderRadius: "0px",
                },
                "& 	.MuiSlider-valueLabelCircle": {
                  "& ::before": {
                    background: "red !important",
                  },
                },
              }}
            />
          </Box>
        </Box>
      </Stack>

      <Box
        display="flex"
        flexDirection="row"
        width="98%"
        marginBottom="5px"
        alignItems={"center"}
        justifyContent={"space-between"}
        pl={1}
        // sx={{ position: "absolute", bottom: 30 }}
      >
        <StyledButton
          onClick={async () => {
            onConfirm();
            // const abc = await isValidRewardToken();
            // console.log("isValidRewardToken", abc);
          }}
          variant="outlined"
          colors={colors}
          disabled={
            nft?.contractType === "ERC1155"
              ? !nftDestination.length | !yieldDestination.length ||
                !amount.length ||
                Number(amount) === 0
              : !nftDestination.length | !yieldDestination.length
          }
        >
          Confirm
        </StyledButton>
      </Box>
    </>
  );
};

export default YieldSplit;
